import { ActionHintDirective } from '@/app/shared/directives/action-hint.directive';
import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '@/app/layout/service/layout.service';
import { AppBreadcrumb } from './app.breadcrumb';
import { ButtonModule } from 'primeng/button';
import { NotificacionesStoreService } from '@/app/pages/notificaciones/notificaciones-store.service';
import { ContextoTenantStore } from '@/app/core/auth/contexto-tenant.store';
import { obtenerRutaAvatar } from '@/app/core/auth/avatar.constants';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [ActionHintDirective, RouterModule, CommonModule, StyleClassModule, AppBreadcrumb, ButtonModule],
    template: `<div class="layout-topbar">
        <div class="topbar-start">
            <button #menubutton type="button" class="topbar-menubutton p-link p-trigger hover:cursor-pointer" (click)="onMenuButtonClick()" appActionHint="Abrir o cerrar menú">
                <i class="pi pi-bars"></i>
            </button>
            <nav app-breadcrumb class="topbar-breadcrumb"></nav>
        </div>

        <div class="topbar-end">
            <ul class="topbar-menu">
                <li class="ml-3">
                    <p-button icon="pi pi-palette" rounded (onClick)="onConfigButtonClick()" appActionHint="Abrir configuración"></p-button>
                </li>
                <li class="ml-3">
                    <p-button
                        icon="pi pi-bell"
                        rounded
                        severity="secondary"
                        [outlined]="true"
                        [routerLink]="['/notificaciones']"
                        [badge]="badgeNotificaciones()"
                        badgeSeverity="danger"
                        ariaLabel="Ver notificaciones"
                     appActionHint="Ver notificaciones" />
                </li>
                <li class="topbar-profile">
                    <button type="button" class="p-link hover:cursor-pointer" aria-label="Abrir perfil" aria-haspopup="dialog" [attr.aria-expanded]="!!layoutService.layoutState().profileSidebarVisible" (click)="onProfileButtonClick()" appActionHint="Abrir perfil">
                        <img [src]="avatarRuta()" alt="Tu avatar" width="40" height="40" class="rounded-full" />
                    </button>
                </li>
            </ul>
        </div>
    </div>`
})
export class AppTopbar {
    @ViewChild('menubutton') menuButton!: ElementRef;

    layoutService = inject(LayoutService);
    readonly notificaciones = inject(NotificacionesStoreService);
    private readonly contexto = inject(ContextoTenantStore);
    readonly avatarRuta = computed(() => obtenerRutaAvatar(this.contexto.sesion()?.avatar));

    readonly badgeNotificaciones = computed(() => {
        const cantidad = this.notificaciones.cantidadNoLeidas();
        if (cantidad === 0) return undefined;
        return cantidad > 99 ? '99+' : String(cantidad);
    });

    onMenuButtonClick() {
        this.layoutService.toggleMenu();
    }

    onProfileButtonClick() {
        this.layoutService.toggleProfileSidebar();
    }

    onConfigButtonClick() {
        this.layoutService.toggleConfigSidebar();
    }
}
